import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

function LanguageSwitcher({ isMobile = false }) {
  const { i18n } = useTranslation()

  const changeLanguage = (lang) => i18n.changeLanguage(lang)

  const containerStyle = isMobile
    ? {
        display: 'flex',
        gap: '20px',
        justifyContent: 'center',
        marginTop: '20px',
      }
    : {
        display: 'flex',
        gap: '0',
        background: 'rgba(0, 0, 0, 0.1)',
        borderRadius: '20px',
        padding: '4px',
        border: '1px solid rgba(0, 0, 0, 0.2)',
      }

  const buttonStyle = (isActive) =>
    isMobile
      ? {
          background: isActive ? '#4a4a4a' : 'transparent',
          color: isActive ? '#fff' : '#999',
          border: isActive ? '2px solid #4a4a4a' : '2px solid #999',
          cursor: 'pointer',
          padding: '8px 16px',
          borderRadius: '20px',
          fontSize: '14px',
          fontWeight: '600',
          transition: 'all 0.3s ease',
          textTransform: 'uppercase',
          letterSpacing: '1px',
          minWidth: '50px',
        }
      : {
          background: isActive ? '#4a4a4a' : 'transparent',
          color: isActive ? '#fff' : '#999',
          border: 'none',
          cursor: 'pointer',
          padding: '6px 12px',
          borderRadius: '16px',
          fontSize: '12px',
          fontWeight: '500',
          transition: 'all 0.3s ease',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
        }

  return (
    <div style={containerStyle}>
      <button onClick={() => changeLanguage('en')} style={buttonStyle(i18n.language === 'en')}>
        EN
      </button>
      <button onClick={() => changeLanguage('fr')} style={buttonStyle(i18n.language === 'fr')}>
        FR
      </button>
    </div>
  )
}

LanguageSwitcher.propTypes = {
  isMobile: PropTypes.bool,
}

export default LanguageSwitcher
